<template lang="html">

  <div class="box table-container">

    <table class='ptpivot_table table is-bordered is-striped is-narrow is-hoverable is-fullwidth'>

      <thead class="ptpivot_header" style="background-color: var(--bulma-box-background-color)">
        <tr class='ptpivot_row'>
          <th class='ptpivot_col' v-bind:colspan="pivot.rowFields.length">

            <div class="level">
              <div class="level-left">
                <div class="level-item">{{config.title}}</div>
              </div>
              <div class="level-right" v-if="data && data.length > 0">
                <div class="level-item buttons">
                  <button class="button is-rounded is-small" v-on:click="export_data()">
                    <span class="icon"><i class="fas fa-file-download"></i></span>
                     <span>export data</span>
                  </button>
                  <button class="button is-rounded is-small" v-on:click="export_pivot()">
                    <span class="icon"><i class="fas fa-file-excel"></i></span>
                     <span>export pivot</span>
                  </button>

                </div>
              </div>
            </div>

          </th>
          <th class='ptpivot_cell' v-bind:colspan="pivot.columnHeaders.length">{{label('col',pivot.columnFields[0])}}</th>
        </tr>
        <tr class='ptpivot_row'>
            <!-- <th class='ptpivot_col' v-bind:colspan="pivot.rowFields.length">{{title}}</th> -->
          <th class='ptpivot_col' v-for="hrow in pivot.rowFields" v-bind:key="hrow">{{label('row',hrow)}}</th>
          <th class='ptpivot_cell' v-for="col in pivot.columnHeaders" v-bind:key="col">{{col}}</th>
        </tr>                
      </thead>

      <tbody>
        <tr class='ptpivot_row' v-for="(row, irow) in pivot.rowHeaders" v-bind:key="row">
          <td class='ptpivot_cell'  v-for="hrow in pivot.rowHeadersSplitted[irow]" v-bind:key="hrow">
            {{hrow}}
          </td>

          <td class='ptpivot_cell' v-for="col in pivot.columnHeaders" v-bind:key="col" style="text-align: right;">
            {{format_number(pivot.data[row][col])}}
          </td>
        </tr>
      </tbody>

    </table>
  
  </div>

</template>

<script>
import moment from 'moment'
import ptpivot from '@/ptpivot2.js'

export default {
  name: 'bulmaPivot',
  components: {
  },
  computed: {
    config: function() {
      return this.$store.getters.getObject(this.id).data;
    },
  },
  props: {
    id: String,
  },
  data() {
    return {
      pivot:{},
      data:[]
    }
  },
  mounted: async function() {

    let records=await this.$store.dispatch('load_query', this.config.query );
    console.log(records);
    this.data=records.data.map(r=>{
      let v=this.flatObject(r, {});
      if (v['Opportunity.CloseDate'])      v['Opportunity.CloseDate']=v['Opportunity.CloseDate'].substring(0,7);
      return v;
    })

    let agg=function (values) {return values.length};
    if (this.config.aggregate=='sum')
      agg=function (values) { return values.reduce((sum, val) => { return val? sum + parseFloat(val): sum}, 0) }

    this.pivot=ptpivot.compute(this.data, this.config.rows, this.config.cols, this.config.fact, agg);

  },
  methods: {
    export_data: function() {
      if (!this.data || this.data.length === 0) {
        console.warn('No data to export.');
        return;
      }

      const headers = Object.keys(this.data[0]);
      const csvRows = [];

      // Add header row, properly escaping quotes
      csvRows.push(headers.map(header => `"${header.replace(/"/g, '""')}"`).join(','));

      // Add data rows
      for (const row of this.data) {
        const values = headers.map(header => {
          let value = row[header];
          if (value === null || value === undefined) {
            value = '';
          } else {
            value = String(value); // Ensure value is a string
          }
          // Escape double quotes and enclose in double quotes if it contains comma, double quote, or newline
          if (value.includes(',') || value.includes('"') || value.includes('\n')) {
            return `"${value.replace(/"/g, '""')}"`;
          }
          return value;
        });
        csvRows.push(values.join(','));
      }

      const csvString = csvRows.join('\n');
      const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.setAttribute('href', url);
      const filename = `${this.config.title ? this.config.title.replace(/[^a-z0-9]/gi, '_') : 'data'}_${moment().format('YYYYMMDD_HHmmss')}.csv`;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    export_pivot: function() {
      if (!this.pivot || !this.pivot.rowHeaders || this.pivot.rowHeaders.length === 0) {
        console.warn('No pivot data to export.');
        return;
      }

      const csvRows = [];

      // Helper function to format values for CSV, handling quotes and commas.
      const toCsvValue = (value) => {
        if (value === null || value === undefined) {
          return '';
        }
        const strValue = String(value);
        if (strValue.includes(',') || strValue.includes('"') || strValue.includes('\n')) {
          return `"${strValue.replace(/"/g, '""')}"`;
        }
        return strValue;
      };

      // 1. Create Header Row from row labels and column headers
      const rowFieldLabels = this.pivot.rowFields.map(f => this.label('row', f));
      const headers = [...rowFieldLabels, ...this.pivot.columnHeaders];
      csvRows.push(headers.map(toCsvValue).join(','));

      // 2. Create Data Rows
      this.pivot.rowHeaders.forEach((rowHeaderKey, index) => {
        const rowHeaderValues = this.pivot.rowHeadersSplitted[index];
        const dataValues = this.pivot.columnHeaders.map(colHeader => {
          const cellData = this.pivot.data[rowHeaderKey] ? this.pivot.data[rowHeaderKey][colHeader] : undefined;
          return cellData; // `toCsvValue` will handle null/undefined
        });
        const fullRow = [...rowHeaderValues, ...dataValues];
        csvRows.push(fullRow.map(toCsvValue).join(','));
      });

      // 3. Combine and Download
      const csvString = csvRows.join('\n');
      const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      const filename = `${this.config.title ? this.config.title.replace(/[^a-z0-9]/gi, '_') : 'pivot_export'}_${moment().format('YYYYMMDD_HHmmss')}.csv`;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    label: function(type,f) {
      if (type=='row') {
        return this.config.row_labels[f];
      }
      if (type=='col') {
        return this.config.col_labels[f];
      }
      return f;
    },
    format_number: function(n) {
      if (n === null || n === undefined) {
        return '';
      }
      return new Intl.NumberFormat('en-US').format(n);
    },
   flatObject: function(obj, flat, prefix='') {
      for (let p in obj) {
        if (p == "attributes") continue;
        if (typeof obj[p] == 'object') {
          this.flatObject(obj[p], flat, prefix+p+'.');
        } else {
          flat[prefix+p]=obj[p];
        }
      }
      return flat;
    }
  }
}

</script>

<style>
.ptpivot_cell {
  white-space: nowrap;
}
.ptpivot_header {
  position: sticky;
  top: 0px;
  z-index: 2;
  background-color: var(--bulma-box-background-color)
}
.ptpivot_table {
  xfont-family: monospace;
  font-size: 11px;
}
.ptpivot_cell2 {
  white-space: nowrap;
  max-width: 250px;
  text-overflow: ellipsis;
  overflow: auto;
}
</style>
